import React, { useState } from 'react';

import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';

import styled from 'styled-components';
import { useSetRecoilState } from 'recoil';
import { modalOpenState } from '@atom/modal/modal';
import Login from '@pages/Register/Login';
import { ModalHeader } from '@components/wrapper/Modal/ModalStyle';
import CloseBtn from '@components/dataEntry/button/CloseBtn/CloseBtn';
import AccountList from './AccountList';
import SignUp from '../SignUp';

const Wrap = styled.div`
  padding: 16px;
`;
const AccountBox = styled.div`
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--lineColor);
`;

function AccountManageModal({ setModal }) {
  const [isLoginPage, setIsLoginPage] = useState(true);

  const toggleLogin = () => setIsLoginPage(!isLoginPage);
  const handleBack = () => setModal(false);

  return (
    <ModalWrapper outsideClick={handleBack} contentStyle={{ minWidth: 420 }}>
      <>
        <ModalHeader>
          <CloseBtn onClick={handleBack} />
          <div style={{ textAlign: 'left' }}>
            <h6>계정 관리</h6>
          </div>
        </ModalHeader>
        <Wrap>
          <AccountBox>
            <AccountList shape="full" />
          </AccountBox>
          {isLoginPage ? (
            <Login
              setTitle={false}
              handleGoBack={false}
              addAccount
              loginText={'계정 추가'}
              toggleLogin={toggleLogin}
            />
          ) : (
            <SignUp handleGoBack={handleBack} toggleLogin={toggleLogin} />
          )}
        </Wrap>
      </>
    </ModalWrapper>
  );
}

export default AccountManageModal;
